import { forwardRef, memo } from 'react';
import Grid from '../../../Grid';

const PopperArrow = forwardRef<HTMLDivElement>((_, ref) => (
  <Grid
    className="popper-arrow"
    ref={ref}
  />
));

export default memo(PopperArrow);
